module.exports = __webpack_public_path__ + "h5/img/open.7da41017.gif";